import { Box, Container, Grid, Theme } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import { Link } from '@mui/material';
import { registrationTheme } from '#app/theme';
import { Children } from '#app/@types/Children';
import { getHelpClicked, signInClicked } from '#app/fullstory-events/events';

interface Props {
  /**
   * The content of the component
   */
  children: Children;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      display: 'flex',
      alignItems: 'center',
      height: '100vh',
    },
    header: {
      display: 'flex',
      [theme.breakpoints.down('md')]: {
        justifyContent: 'flex-start',
        marginBottom: 16,
      },
      [theme.breakpoints.up('md')]: {
        justifyContent: 'space-around',
        marginBottom: 32,
      },
    },
    footer: {
      display: 'flex',
      justifyContent: 'center',
      paddingBottom: 21,
      paddingTop: 21,
    },
    rightHalf: {
      backgroundColor: theme.palette.primary.main,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100%',
      [theme.breakpoints.down('md')]: {
        display: 'none',
      },
      [theme.breakpoints.up('md')]: {
        display: 'flex',
      },
    },
    leftHalf: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      alignContent: 'space-between',
      [theme.breakpoints.down('md')]: {
        padding: 24,
      },
      [theme.breakpoints.up('md')]: {
        padding: '24px 56px',
      },
    },
    signinTop: {
      [theme.breakpoints.down('md')]: {
        display: 'none',
      },
      [theme.breakpoints.up('md')]: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'flex-end',
      },
    },
    signinLower: {
      [theme.breakpoints.down('md')]: {
        display: 'flex',
        marginTop: 24,
        flexDirection: 'row',
      },
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
  })
);

function RegistrationLayout(props: Props) {
  const classes = useStyles();
  const { children } = props;

  return (
    <Container disableGutters className={classes.wrapper}>
      <Grid container style={{ minHeight: '100%' }}>
        <Grid container item xs={12} md={6} className={classes.leftHalf}>
          <Grid className={classes.header} item xs={12}>
            <img src={require('#app/icons/TNLogo.svg').default} alt="TNLogo" />
            <Grid className={classes.signinTop} component={Box}>
              <div style={{ color: '#718096' }}>Already have an account?</div>
              <Link
                href="/"
                onClick={signInClicked}
                style={{
                  color: registrationTheme.palette.primary.main,
                  textDecoration: 'none',
                  fontWeight: 500,
                  marginLeft: 6,
                }}>
                Sign In
              </Link>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            {children}
          </Grid>
          <Grid className={classes.footer} item xs={12}>
            <Link href="mailto:onboardingcustomersupport@gettruenorth.com" onClick={getHelpClicked}>
              <img
                src={require('#app/icons/getHelp.svg').default}
                alt="getHelp"
              />
            </Link>
          </Grid>
        </Grid>
        <Grid item xs={6} className={classes.rightHalf} component={Box}>
          <img
            src={require('#app/icons/ForestTruck.svg').default}
            alt="forestTruck"
          />
        </Grid>
      </Grid>
    </Container>
  );
}

export default RegistrationLayout;
